// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@/assets/styles/style.scss';
import Vue from 'vue';
import Vuex from 'vuex';
import retina from 'retinajs';
import VueRetina from 'vue-retina';
import VueTouch from 'vue-touch-easyhi';
import VueAnalytics from 'vue-analytics';

import App from './App';
import store from '../store';

Vue.config.productionTip = false;
Vue.use(Vuex);

Vue.use(VueRetina, { retina });

VueTouch.config.swipe = {
  direction: 'horizontal',
};

Vue.use(VueAnalytics, {
  id: 'UA-9347930-11',
});

Vue.use(VueTouch);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  store,
});

// GA
Vue.$ga.page({
  page: '/',
  title: 'Home page',
  location: window.location.href,
});



// WEBPACK FOOTER //
// ./src/main.js